export const banner_style = "overflow-x-hidden w-full h-[58vh] min-h-[300px] text-center flex justify-center items-center bg-black mb-8";
